import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { GateWayService } from 'src/app/services/gateway.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {Observable, of} from 'rxjs';
import * as featureActions from '../../index';
import {catchError, combineLatest, map, mergeMap, switchMap, withLatestFrom} from 'rxjs/operators';
import { GateWayDiscoveryActions, GateWayDiscoveryActionTypes } from '../actions/gateway-discovery.actions';
import { UpdateInfoModel } from '../../updateInfo/update-info.model';
import { updateInfoType } from '../../../shareModel';
import {PreferenceService} from '../../../services/preference.service';

@Injectable()
export class GateWayDiscoveryEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private getwayService = inject(GateWayService);
  private preferenceService = inject(PreferenceService);

  constructor() {}

  ReadDiscoveryInfoList$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayDiscoveryActionTypes.ReadDiscoveryInfoList),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      let param = action.payload == null ? null : { ...action.payload };
      if (param == null) {
        param = {otp: user.otp};
      } else if (param.RegionIds !== undefined && param.RegionIds.length > 0 ) {
        param = { ...param, otp: user.otp };
      } else {
        param = {otp: user.otp};
      }
      return this.getwayService.ReadDiscoveryInfoList(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [
                    new featureActions.UpsertDiscoveryInfoList(res.msg.body)];
          } else {
            return [new featureActions.ReadDiscoveryInfoListFail(res.errmsg.body)];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.ReadDiscoveryInfoListFail(error)];
        })
      );
    })
  ));
  ReadDiscoveryInfo$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayDiscoveryActionTypes.ReadDiscoveryInfo),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const param = { ...action.payload, otp: user.otp };
      return this.getwayService.ReadDiscoveryInfo(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [
                    new featureActions.UpsertDiscoveryInfo(res.msg.body)];
          } else {
            return [new featureActions.ReadDiscoveryInfoFail(res.errmsg.body)];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.ReadDiscoveryInfoFail(error)];
        })
      );
    })
  ));
  AddDiscoveryInfo$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayDiscoveryActionTypes.AddDiscoveryInfo),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.AddDiscoveryInfo
      };
      const param = { ...action.payload, otp: user.otp };
      return this.getwayService.AddDiscoveryInfo(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.ReadDiscoveryInfoList(), new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result, msg: 'Add Discovery Info Success' })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Add Discovery Info Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));
  UpdateDiscoveryInfo$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayDiscoveryActionTypes.UpdateDiscoveryInfo),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.UpdateDiscoveryInfo
      };
      const param = { ...action.payload, otp: user.otp };
      return this.getwayService.UpdateDiscoveryInfo(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.ReadDiscoveryInfoList(), new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result, msg: 'Update Discovery Info Success' })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Update Discovery Info Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: 'Update Discovery Info Fail' })];
        })
      );
    })
  ));
  DeleteDiscoveryInfo$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayDiscoveryActionTypes.DeleteDiscoveryInfo),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.DeleteDiscoveryInfo
      };
      const param = { ...action.payload, otp: user.otp };
      return this.getwayService.DeleteDiscoveryInfo(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.ReadDiscoveryInfoList(), new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result, msg: 'Delete Discovery Info Success' })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Delete Discovery Info Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));
  ExecuteDiscoveryList$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayDiscoveryActionTypes.ExecuteDiscoveryList),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const param = action.payload == null ? {otp: user.otp} : { ...action.payload, otp: user.otp };
      return this.getwayService.ExecuteDiscoveryList(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [
                    new featureActions.ExecuteDiscoveryListSuccess(res.msg.body)];
          } else {
            return [new featureActions.ExecuteDiscoveryListFail(res.errmsg.body)];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.ExecuteDiscoveryListFail(error)];
        })
      );
    })
  ));
  ExecuteDiscovery$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayDiscoveryActionTypes.ExecuteDiscovery),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.ExecutingDiscovery
      };
      const param = { ...action.payload, otp: user.otp };
      return this.getwayService.ExecuteDiscovery(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [
                    new featureActions.ExecuteDiscoverySuccess(res.msg.body),
                    new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result, msg: 'Execute Discovery Success' })
                  ];
          } else {
            return [new featureActions.ExecuteDiscoveryFail(res.errmsg.body), new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Execute Discovery Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.ExecuteDiscoveryFail(error), new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: 'Execute Discovery Fail' })];
        })
      );
    })
  ));
  StopExecutingDiscovery$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayDiscoveryActionTypes.StopExecutingDiscovery),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.StopExecutingDiscovery
      };
      const param = { ...action.payload, otp: user.otp };
      return this.getwayService.StopExecutingDiscovery(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [
              new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result, msg: 'Stop Executing Discovery Success' })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Stop Executing Discovery Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: 'Stop Executing Discovery Fail' })];
        })
      );
    })
  ));
  ConfirmExecutingDiscovery$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayDiscoveryActionTypes.ConfirmExecutingDiscovery),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.ConfirmExecutingDiscovery
      };
      const param = { ...action.payload, otp: user.otp };
      return this.getwayService.ConfirmExecutingDiscovery(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [
              new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result, msg: 'Confirm Executing Discovery Success' })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Confirm Executing Discovery Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: 'Confirm Executing Discovery Fail' })];
        })
      );
    })
  ));
  ReadDiscoveryResultList$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayDiscoveryActionTypes.ReadDiscoveryResultList),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const param = action.payload == null ? { otp: user.otp } : { ...action.payload, otp: user.otp };
      return this.getwayService.ReadDiscoveryResultList(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.UpsertDiscoveryResultList(res.msg.body)];
          } else {
            return [new featureActions.ReadDiscoveryResultListFail(res.errmsg.body)];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.ReadDiscoveryResultListFail(error)];
        })
      );
    })
  ));
  AddDiscoveryResult$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayDiscoveryActionTypes.AddDiscoveryResult),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.AddDiscoveryResult
      };
      const param = { ...action.payload, otp: user.otp };
      return this.getwayService.AddDiscoveryResult(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.ReadDiscoveryResultList(), new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result, msg: 'Add Discovery Result Success' })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Add Discovery Result Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));
  ReadDiscoveryExecutingResultForOneTime$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayDiscoveryActionTypes.ReadDiscoveryExecutingResultForOneTime),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const param = { ...action.payload, otp: user.otp };
      return this.getwayService.ReadDiscoveryExecutingResultForOneTime(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.ReadDiscoveryExecutingResultForOneTimeSuccess(res.msg.body)];
          } else {
            return [new featureActions.ReadDiscoveryExecutingResultForOneTimeFail(res.errmsg.body)];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.ReadDiscoveryExecutingResultForOneTimeFail(error)];
        })
      );
    })
  ));
}
